<div fxLayout *ngIf="{ agreements: agreements$ | async, agreementsError: agreementsError$ | async } as vm">
  <div
    style="padding-top: 24px"
    fxFlex
    [ngClass.lt-md]="{ mobile: true }"
    class="subnav__exists"
    fxLayout="column"
    fxLayoutGap="32px">
    <!-- Loading -->
    <ng-container *ngTemplateOutlet="loadingSection; context: { vm: vm }"></ng-container>

    <!-- Error -->
    <ng-container *ngTemplateOutlet="errorSection; context: { vm: vm }"></ng-container>

    <!-- No agreements created yet -->
    <ng-container *ngTemplateOutlet="noDataSection; context: { vm: vm }"></ng-container>

    <!-- Happy path - we have agreements -->
    <section *ngIf="vm.agreements?.length > 0">
      <div class="hidden lg:flex w-full gap-3 rules__rule-header">
        <div class="flex items-center gap-3 flex-1">
          <div class="w-[32px]">Status</div>
          <div class="flex-1">Name</div>
        </div>
        <div class="flex gap-3 lg:w-[280px]">
          <div class="w-[140px]">Platforms</div>
          <div class="w-[140px]">Properties</div>
        </div>
      </div>

      <a
        *ngFor="let agreement of vm.agreements"
        class="rules__rule-container"
        [routerLink]="['/gx/rental-agreements', agreement.uuid]">
        <div class="flex flex-col lg:flex-row w-full gap-3 items-start lg:items-center">
          <!-- Toggle and Name Row -->
          <div class="flex items-center gap-3 flex-1">
            <div class="p-2 -m-2" (click)="$event.stopPropagation()">
              <mat-slide-toggle
                [checked]="agreement.is_active"
                (change)="activateOrDeactivateAgreement(agreement, $event)"></mat-slide-toggle>
            </div>
            <strong class="flex-1">{{ agreement.name }}</strong>
          </div>

          <!-- Platforms and Properties Row -->
          <div class="flex gap-1 lg:gap-3 lg:w-[280px] justify-start">
            <div class="w-auto lg:w-[140px] flex items-center">
              <ng-container *ngIf="agreement.platforms && agreement.platforms.length > 0">
                <sbnb-icon-platform
                  *ngFor="let platform of agreement.platforms"
                  class="platform-icon"
                  [platform]="platform"></sbnb-icon-platform>
              </ng-container>
            </div>

            <div class="w-auto lg:w-[140px] flex">
              <sbnb-avatar-group
                [items]="agreement.property_list"
                [itemsForLabel]="agreement.name"
                allItemsLabel="Default"
                [expandAllItems]="true"></sbnb-avatar-group>
            </div>
          </div>
        </div>
      </a>
    </section>
  </div>

  <ng-template #loadingSection let-vm="vm">
    <ng-container *ngIf="vm.agreements === null && !vm.agreementsError">
      <div class="animate-pulse space-y-2">
        <!-- Row shimmers -->
        <div *ngFor="let i of [].constructor(20)" class="space-y-2">
          <div class="flex items-center space-x-3 p-4 border-b border-gray-200">
            <div class="w-[70%]">
              <div class="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
            <div class="w-[30%]">
              <div class="flex-1 flex space-x-1">
                <div class="h-4 bg-gray-200 rounded w-4"></div>
                <div class="h-4 bg-gray-200 rounded w-4"></div>
                <div class="h-4 bg-gray-200 rounded w-4"></div>
              </div>
            </div>
            <div class="w-[140px]">
              <div class="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #errorSection let-vm="vm">
    <ng-container *ngIf="vm.agreementsError">There was an error loading reservation agreements.</ng-container>
  </ng-template>

  <ng-template #noDataSection let-vm="vm">
    <ng-container *ngIf="vm.agreements?.length === 0 && !vm.agreementsError">
      <sbnb-no-items
        text="No reservation agreements"
        subtext="You haven't created any reservation agreements yet."></sbnb-no-items>
    </ng-container>
  </ng-template>
</div>
